<section class="border border-aux-gray-dark bg-aux-gray-light p-4">
  <p class="mb-4 font-bold">
    @switch (formValues.source) {
      @case (sourceTypes.Contracted) {
        <span>Contracted Investigator Amount</span>
      }
      @case (sourceTypes.Averages) {
        <span>Site Contract Settings</span>
      }
      @case (sourceTypes.PatientVisits) {
        <p>
          Forecast Through End of Trial
          <span class="font-normal italic">(Best used when trial is fully enrolled)</span>
        </p>
      }
    }
  </p>

  <aux-investigator-forecast-overview-amount
    [ngClass]="{
      hidden:
        formValues.source === sourceTypes.Averages ||
        formValues.source === sourceTypes.PatientVisits,
    }"
    [values]="formValues.contracted"
  />

  <aux-investigator-forecast-overview-averages
    [ngClass]="{
      hidden:
        formValues.source === sourceTypes.Contracted ||
        formValues.source === sourceTypes.PatientVisits,
    }"
    [form]="form"
  />

  <aux-investigator-forecast-overview-patient-visits
    [ngClass]="{
      hidden:
        formValues.source === sourceTypes.Contracted || formValues.source === sourceTypes.Averages,
    }"
    [form]="form"
  />

  @if (getBottomTotalValuesBySelectedSource(); as bottomValues) {
    <div class="my-4 flex justify-end space-x-4">
      <div>
        <p>Forecasted Total Investigator Cost</p>
        <p class="text-right font-bold">{{ bottomValues?.totalInvestigatorCosts | money }}</p>
      </div>
      <div class="h-12 border-l border-aux-gray-dark"></div>
      <div>
        <p>Forecasted Remaining Investigator Cost</p>
        <p class="text-right font-bold">{{ bottomValues?.remainingAmount | money }}</p>
      </div>
    </div>
  }
</section>
